module.exports = __webpack_public_path__ + "img/external.8eb60c2a.svg";